export default __webpack_public_path__ + "static/media/1778.3681b3e3.png";